var escape = require("../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RelatedMedia_item__3yO7Q{cursor:pointer;max-width:281px;min-height:190px;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}@media only screen and (max-width:960px){.RelatedMedia_item__3yO7Q{max-width:100%}}.RelatedMedia_label__27wJM{margin-top:10px;font-size:14px;line-height:20px;color:#333}.RelatedMedia_media__2eyAj{position:relative;height:158px;overflow:hidden;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}.RelatedMedia_mediaPreview__3nxBK{width:100%;height:auto;box-shadow:0 0 2px 0 rgba(51,51,51,.14),0 3px 5px 0 rgba(51,51,51,.1)}.RelatedMedia_mediaTitle__1IR_l{color:#3dcd58}.RelatedMedia_video__iBoaf:before{content:\"\";position:absolute;display:block;width:0;height:0;border:8px solid transparent;border-left:10px solid #fff;z-index:1;border-radius:3px;top:0;bottom:0;right:0;left:12px;margin:auto}.RelatedMedia_video__iBoaf:after{-webkit-transition:background-color .1s;transition:background-color .1s}.RelatedMedia_threeD__J2RWc:after,.RelatedMedia_video__iBoaf:after{content:\"\";position:absolute;width:50px;height:50px;background-color:#3dcd58;border-radius:50%;top:0;bottom:0;right:0;left:0;margin:auto}.RelatedMedia_threeD__J2RWc:after{display:-webkit-inline-box;display:inline-flex;background-image:url(" + escape(require("../../../../../assets/images/threeDicon.svg")) + ");background-repeat:no-repeat;background-size:30px;background-position-x:center;background-position-y:9px;z-index:2}", ""]);

// exports
exports.locals = {
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333",
	"textGray": "#9b9b9b",
	"textWhite": "#fff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"containerWidthMain": "960",
	"heightDesktopHeader": "136px",
	"item": "RelatedMedia_item__3yO7Q",
	"label": "RelatedMedia_label__27wJM",
	"media": "RelatedMedia_media__2eyAj",
	"mediaPreview": "RelatedMedia_mediaPreview__3nxBK",
	"mediaTitle": "RelatedMedia_mediaTitle__1IR_l",
	"video": "RelatedMedia_video__iBoaf",
	"threeD": "RelatedMedia_threeD__J2RWc"
};